var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { sm: "12", md: "9" } },
            [
              _c("j-title-header", {
                attrs: { options: _vm.titleEmploymentData }
              }),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "12", md: "12" } },
                    [
                      _c(
                        "b-form-group",
                        [
                          _c("label", [_vm._v(" Employee Code ")]),
                          _vm._v(" "),
                          _c("j-input", {
                            attrs: {
                              "max-length": 50,
                              placeholder: "Employee Code"
                            },
                            model: {
                              value: _vm.data_employee.code,
                              callback: function($$v) {
                                _vm.$set(_vm.data_employee, "code", $$v)
                              },
                              expression: "data_employee.code"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "12", md: "6" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          class: {
                            "error-input":
                              _vm.$v.selected_employment_type.$error
                          }
                        },
                        [
                          _c("label", [_vm._v(" Employment Type ")]),
                          _vm._v(" "),
                          _c("j-single-select", {
                            attrs: {
                              options: _vm.list_type_employee,
                              label: "name",
                              placeholder: "Select Employment Type"
                            },
                            model: {
                              value: _vm.selected_employment_type,
                              callback: function($$v) {
                                _vm.selected_employment_type = $$v
                              },
                              expression: "selected_employment_type"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.isHaveSub
                    ? _c(
                        "b-col",
                        { attrs: { sm: "12", md: "6" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              class: {
                                "error-input":
                                  _vm.$v.selected_employment_subtype.$error
                              }
                            },
                            [
                              _c("label", [_vm._v(" Employment Sub Type ")]),
                              _vm._v(" "),
                              _c("j-single-select", {
                                attrs: {
                                  options: _vm.list_subtype_employee,
                                  label: "name",
                                  placeholder: "Select Employment Sub Type"
                                },
                                model: {
                                  value: _vm.selected_employment_subtype,
                                  callback: function($$v) {
                                    _vm.selected_employment_subtype = $$v
                                  },
                                  expression: "selected_employment_subtype"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm.data_employee.employment_type === "CONTRACT"
                ? _c(
                    "b-row",
                    [
                      _c("b-col", { attrs: { md: "6" } }),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { md: "6" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              class: {
                                "error-input":
                                  _vm.$v.data_employee.contract_type.$error
                              }
                            },
                            [
                              _c("label", [_vm._v("Contract Type*")]),
                              _vm._v(" "),
                              _c("j-single-select", {
                                attrs: {
                                  options: _vm.contract_type_option,
                                  label: "name",
                                  placeholder: "Select Contract Type"
                                },
                                model: {
                                  value: _vm.data_employee.contract_type,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.data_employee,
                                      "contract_type",
                                      $$v
                                    )
                                  },
                                  expression: "data_employee.contract_type"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.data_employee.employment_type === "CONTRACT"
                ? _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "6" } },
                        [
                          _c(
                            "b-form-group",
                            [
                              _c("label", [_vm._v("Contract Start Date")]),
                              _vm._v(" "),
                              _c("j-datepicker", {
                                attrs: {
                                  "disabled-dates":
                                    _vm.disabled_contract_start_date,
                                  format: "MMM dd, yyyy",
                                  placeholder: "Jan 01, 2020"
                                },
                                model: {
                                  value: _vm.data_employee.contract_start_date,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.data_employee,
                                      "contract_start_date",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "data_employee.contract_start_date"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { md: "6" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              class: {
                                "error-input":
                                  _vm.$v.data_employee.contract_end_date.$error
                              }
                            },
                            [
                              _c("label", [_vm._v("Contract End Date*")]),
                              _vm._v(" "),
                              _c("j-datepicker", {
                                attrs: {
                                  "disabled-dates":
                                    _vm.disabled_contract_end_date,
                                  format: "MMM dd, yyyy",
                                  placeholder: "Jan 01, 2020"
                                },
                                model: {
                                  value:
                                    _vm.$v.data_employee.contract_end_date
                                      .$model,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.$v.data_employee.contract_end_date,
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "$v.data_employee.contract_end_date.$model"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "6" } },
                    [
                      _c(
                        "b-form-group",
                        [
                          _c("label", [_vm._v(" Join Date ")]),
                          _vm._v(" "),
                          _c("j-datepicker", {
                            attrs: {
                              "disabled-dates": _vm.disabled_start_dates,
                              format: "MMM dd, yyyy",
                              placeholder: "Jan 01, 2020"
                            },
                            model: {
                              value: _vm.data_employee.join_date,
                              callback: function($$v) {
                                _vm.$set(_vm.data_employee, "join_date", $$v)
                              },
                              expression: "data_employee.join_date"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { md: "6" } },
                    [
                      _c(
                        "b-form-group",
                        [
                          _c("label", [_vm._v(" End Date ")]),
                          _vm._v(" "),
                          _c("j-datepicker", {
                            attrs: {
                              "disabled-dates": _vm.disabled_end_dates,
                              format: "MMM dd, yyyy",
                              placeholder: "Jan 01, 2020"
                            },
                            model: {
                              value: _vm.data_employee.end_date,
                              callback: function($$v) {
                                _vm.$set(_vm.data_employee, "end_date", $$v)
                              },
                              expression: "data_employee.end_date"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.data_employee.employment_type === "CONTRACT" &&
              _vm.data_employee.contract_start_date &&
              _vm.data_employee.contract_end_date
                ? _c(
                    "b-row",
                    [
                      _c("b-col", { attrs: { md: "6" } }),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { md: "6" } },
                        [
                          _c(
                            "b-form-group",
                            [
                              _c("label", [_vm._v("Contract Time Remaining")]),
                              _vm._v(" "),
                              _c("j-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value:
                                    _vm.data_employee.contract_time_remaining,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.data_employee,
                                      "contract_time_remaining",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "data_employee.contract_time_remaining"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "12", md: "6" } },
                    [
                      _c(
                        "b-form-group",
                        [
                          _c("label", [_vm._v(" Employee Status ")]),
                          _vm._v(" "),
                          _c("j-single-select", {
                            attrs: {
                              options: _vm.status_option,
                              label: "name",
                              "value-format": "object",
                              placeholder: "Select Employee Status"
                            },
                            model: {
                              value: _vm.data_employee.employee_status,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.data_employee,
                                  "employee_status",
                                  $$v
                                )
                              },
                              expression: "data_employee.employee_status"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.data_employee.employee_status
                    ? _c(
                        "b-col",
                        { attrs: { sm: "12", md: "6" } },
                        [
                          _vm.data_employee.employee_status.id === 0
                            ? _c(
                                "b-form-group",
                                {
                                  class: {
                                    "error-input":
                                      _vm.$v.data_employee.nonactive_reason
                                        .$error
                                  }
                                },
                                [
                                  _c("label", [_vm._v("Nonactive Reason*")]),
                                  _vm._v(" "),
                                  _c("j-single-select", {
                                    attrs: {
                                      options: _vm.nonactive_reason_option,
                                      label: "name",
                                      placeholder: "Select Nonactive Reason"
                                    },
                                    model: {
                                      value: _vm.data_employee.nonactive_reason,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.data_employee,
                                          "nonactive_reason",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "data_employee.nonactive_reason"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm.data_employee.employee_status.id === 1
                            ? _c(
                                "b-form-group",
                                {
                                  class: {
                                    "error-input":
                                      _vm.$v.data_employee.active_reason.$error
                                  }
                                },
                                [
                                  _c("label", [_vm._v("Active Reason*")]),
                                  _vm._v(" "),
                                  _c("j-single-select", {
                                    attrs: {
                                      options: _vm.active_reason_option,
                                      label: "name",
                                      placeholder: "Select Active Reason"
                                    },
                                    model: {
                                      value: _vm.data_employee.active_reason,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.data_employee,
                                          "active_reason",
                                          $$v
                                        )
                                      },
                                      expression: "data_employee.active_reason"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "12", md: "12" } },
                    [
                      _c(
                        "b-form-group",
                        [
                          _c("label", [_vm._v(" Departments ")]),
                          _vm._v(" "),
                          _c("j-single-select", {
                            attrs: {
                              options: _vm.list_teams,
                              label: "name",
                              "value-format": "object",
                              placeholder: "Select Departments"
                            },
                            model: {
                              value: _vm.data_employee.teams,
                              callback: function($$v) {
                                _vm.$set(_vm.data_employee, "teams", $$v)
                              },
                              expression: "data_employee.teams"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "6" } },
                    [
                      _c(
                        "b-form-group",
                        [
                          _c("label", [_vm._v("Location")]),
                          _vm._v(" "),
                          _c("j-single-select", {
                            attrs: {
                              options: _vm.list_company,
                              placeholder: "Select Company",
                              label: "name"
                            },
                            model: {
                              value: _vm.data_employee.company_location,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.data_employee,
                                  "company_location",
                                  $$v
                                )
                              },
                              expression: "data_employee.company_location"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "12", md: "6" } },
                    [
                      _c(
                        "b-form-group",
                        [
                          _c("label", [_vm._v("Country of Office Address")]),
                          _vm._v(" "),
                          _c("j-single-select", {
                            attrs: {
                              options: _vm.list_country,
                              placeholder: "Select Country",
                              label: "name"
                            },
                            on: { select: _vm.resetOfficeProvince },
                            model: {
                              value: _vm.data_employee.office_country,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.data_employee,
                                  "office_country",
                                  $$v
                                )
                              },
                              expression: "data_employee.office_country"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.data_employee.office_country,
                              expression: "data_employee.office_country"
                            }
                          ]
                        },
                        [
                          _c("label", [_vm._v("Province of Office Address")]),
                          _vm._v(" "),
                          _c("j-single-select", {
                            attrs: {
                              options: _vm.office_province_options,
                              placeholder: "Select Province",
                              label: "name"
                            },
                            on: { input: _vm.getCity },
                            model: {
                              value: _vm.data_employee.office_province,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.data_employee,
                                  "office_province",
                                  $$v
                                )
                              },
                              expression: "data_employee.office_province"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.show_office_city,
                              expression: "show_office_city"
                            }
                          ]
                        },
                        [
                          _c("label", [_vm._v("City of Office Address")]),
                          _vm._v(" "),
                          _c("j-single-select", {
                            attrs: {
                              options: _vm.office_city_options,
                              placeholder: "Select City",
                              label: "name"
                            },
                            model: {
                              value: _vm.data_employee.office_city,
                              callback: function($$v) {
                                _vm.$set(_vm.data_employee, "office_city", $$v)
                              },
                              expression: "data_employee.office_city"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "12", md: "12" } },
                    [
                      _c(
                        "b-form-group",
                        [
                          _c("label", [_vm._v(" Office Address ")]),
                          _vm._v(" "),
                          _c("j-textarea", {
                            attrs: { placeholder: "Office Address" },
                            model: {
                              value: _vm.data_employee.office_address,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.data_employee,
                                  "office_address",
                                  $$v
                                )
                              },
                              expression: "data_employee.office_address"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("b-col", { attrs: { sm: "12", md: "3" } })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c8ea6fb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c8ea6fb","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user-employee/assignment/jAssignmentFormUpdate.vue
// module id = null
// module chunks = 